import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsPicRegraClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/pic-regra');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic Regra');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/pic-regra', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic Regra');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/pic-regra', data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/pic-regra/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Pic Regra');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/pic-regra/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Pic Regra');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/pic-regra/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Pic Regra');
    }
  }
}
